import { merge } from 'lodash';
import tracker from '../TrackingService';
import { getBQClickFields } from '../reportEvent';

export const reportHelpfulEvent = (type, { state, reviewId, encryptedOrderId }) => {
    const baseFields = getBQClickFields({
        type: type.BigQuery,
        elementName: 'helpful_reviews',
        elementType: 'button',
        componentName: 'review',
    });
    tracker.sendBQEvent(
        merge(baseFields, {
            page: {
                element: {
                    type: 'button',
                    state,
                },
            },
            review: {
                id: reviewId,
            },
            order: {
                encrypted_id: encryptedOrderId,
            },
        })
    );

    tracker.sendMixPanelEvent({
        eventName: type.Mixpanel,
        eventPayload: {
            'Review Id': reviewId,
            'Encrypted Order Id': encryptedOrderId,
            'Thumb State': state,
        },
    });
};

export const Events = {
    clickedOnHelpfulReview: {
        BigQuery: 'clicked_on_helpful_review',
        Mixpanel: 'Clicked Helpful Review',
    },
    clickedOnNotHelpfulReview: {
        BigQuery: 'clicked_on_not_helpful_review',
        Mixpanel: 'Clicked Not Helpful Review',
    },
};
